module.exports = __webpack_public_path__ + "static/media/vf_wsweater_core.93d6314d.svg";